import { render, staticRenderFns } from "./por_programa.vue?vue&type=template&id=0718f97e"
import script from "./por_programa.vue?vue&type=script&lang=js"
export * from "./por_programa.vue?vue&type=script&lang=js"
import style0 from "./por_programa.vue?vue&type=style&index=0&id=0718f97e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports